import React from 'react'
import { Link } from 'react-router-dom'
import { menu } from './menu'
import SingleCategoryBox from './SingleCategoryBox'

const CategoryBoxes = () => {
	return (
		<div className='categoryContainer mt-11 grid grid-cols-3 gap-4'>
			{menu.map((category, key) => {
				let s = category.name.split(' ')
				return (
					<Link key={key} to={'/category'} state={{ categoryID: `category-${key}` }}>
						<SingleCategoryBox
							id={`category-${key}`}
							categoryName={category.name}
							categoryImg={category.img}
						></SingleCategoryBox>
					</Link>
				)
			})}
		</div>
	)
}

export default CategoryBoxes
